import 'core-js/stable';
import 'raf/polyfill';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';

import { setupDataLayerSetup } from './dataLayer/PluginDataLayer.tsx';
import { pluginInit } from './dom/PluginInit.tsx';

// setup datalayer
setupDataLayerSetup('$openpix');
setupDataLayerSetup('$openPix');
setupDataLayerSetup('$woovi');

// render Pix to manage isOpen and websockets
pluginInit();
